export default __webpack_public_path__ + "static/media/waterfalls5.5a81fafd.webp";